import React from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");

    if (!token) {
        // Kein Token -> Weiterleitung zur Login-Seite
        return <Navigate to="/login" />;
    }

    try {
        const decodedToken = jwtDecode(token);
        // Ablaufprüfung
        const currentTime = Date.now() / 1000; // Zeit in Sekunden
        if (decodedToken.exp < currentTime) {
            console.error("Token ist abgelaufen");
            localStorage.removeItem("token");
            return <Navigate to="/login" />;
        }

        if (decodedToken.is_admin) {
            // Admin-Rechte -> Zugriff gewähren
            return children;
        } else {
            // Kein Admin -> Weiterleitung zur Startseite
            return <Navigate to="/" />;
        }
    } catch (error) {
        console.error("Ungültiger Token:", error);
        return <Navigate to="/login" />;
    }
};

export default ProtectedRoute;